// Landesverbands-IDs
export const LANDESVERBAND = {
  WNB: '1', // Wien, Niederösterreich, Burgenland
  OOE: '4', // Oberösterreich
}
